import React from 'react';
import Work from '../components/Work';

const WorkPage = () => {
    return (
        <div>
            <Work />
        </div>
    )
}

export default WorkPage;